export const REPORT_STATUS = {
	READY: 'ready',
	RUNNING: 'running',
	GENERATING: 'generating',
	STOPPED: 'stopped'
}